export const errorMessages = {
  SCHOOL_NAME_REQUIRED: 'Educational Institution is Required',
  ADDRESS_LINE_ONE: 'Address Line 1 is Required',
  ADDRESS_LINE_TWO: 'Address Line 2 is Required',
  STATE: 'State is Required',
  CITY: 'City is Required',
  ZIP: 'Zip is Required',
  CHARITY_NAME: 'Charity Name is Required',
  INVALID_ADDRESS_LINE_ONE: 'Invalid Address Line 1',
  INVALID_ADDRESS_LINE_TWO: 'Invalid Address Line 2',
  INVALID_CITY: 'Invalid City',
  INVALID_STATE: 'Invalid State',
  INVALID_ZIP: 'Invalid Zip',
  INVALID_ZIP_EXT: 'Invalid Zip Ext',
  INVALID_STUDENT_ID: 'Invalid Student Id',
  INVALID_CHARITY_NAME: 'Invalid Charity Name',
  ADDRESS_CHARACTER_LIMIT: 'Maximum of 35 Characters Allowed',
  CITY_CHARACTER_LIMIT: 'Maximum of 20 Characters Allowed',
  VALID_INSTITUTION_NAME: 'Please Select a Valid Institution Name',
  REQUIRED: 'Required Field',
};

export const ADDRESS_REGEX = /^$|^([ A-Za-z0-9#.,'‘’()\-@&]+)$/i;
export const ZIP_REGEX = /^([0-9]{5})*$/;
export const ZIPEXT_REGEX = /^([0-9]{4})*$/;
export const STATE_REGEX = /^[A-Z]{2}$/;
export const CITY_REGEX =
  /^[ a-zA-Z.,'‘’()#\-@&]+(?:[\s-][ a-zA-Z.,'‘’()#\-@&]+)*$/;
export const STUDENT_ID_REGEX = /^[a-zA-Z0-9]+$/;

const runValidation = (validation, errorMessage) => (data) => {
  const isValid = validation(data);
  return isValid ? true : errorMessage;
};

export const handleMultipleValidations = (inputValue, validations) => {
  const validationErrors = validations.map((validation) =>
    validation(inputValue)
  );
  const errorIndex = validationErrors.findIndex((element) => element !== true);
  return errorIndex !== -1 ? validations[errorIndex](inputValue) : true;
};

export const isFieldRequired = runValidation(
  (a) => a && a.length > 0,
  'Required Field'
);

export const isValidSchoolName = runValidation(
  (a) => a && a.length >= 2,
  'Invalid Educational Institution'
);

export const isValidAddressOne = runValidation(
  (a) => a.length > 0 && ADDRESS_REGEX.test(a),
  errorMessages.INVALID_ADDRESS_LINE_ONE
);

export const isMaxCharacterLimitAddress = runValidation(
  (a) => a.length <= 35,
  errorMessages.ADDRESS_CHARACTER_LIMIT
);

export const isValidAddressTwo = runValidation(
  (a) => ADDRESS_REGEX.test(a),
  errorMessages.INVALID_ADDRESS_LINE_TWO
);

export const isValidCity = runValidation(
  (a) => a && a.length <= 35 && CITY_REGEX.test(a),
  errorMessages.INVALID_CITY
);

export const isMaxCharacterLimitCity = runValidation(
  (a) => a.length <= 20,
  errorMessages.CITY_CHARACTER_LIMIT
);

export const isValidState = runValidation(
  (a) => a && STATE_REGEX.test(a),
  errorMessages.INVALID_STATE
);

export const isValidZip = runValidation(
  (a) => a && a.length === 5 && ZIP_REGEX.test(a),
  errorMessages.INVALID_ZIP
);

export const isValidZipExt = runValidation(
  (a) => !a || (a.length === 4 && ZIPEXT_REGEX.test(a)),
  errorMessages.INVALID_ZIP_EXT
);

export const isValidStudentId = runValidation(
  (a) => !a || (a.length > 0 && STUDENT_ID_REGEX.test(a)),
  errorMessages.INVALID_STUDENT_ID
);

const addressOneValidation = [isValidAddressOne, isMaxCharacterLimitAddress];
const addressTwoValidation = [isValidAddressTwo, isMaxCharacterLimitAddress];
const cityValidation = [isValidCity, isMaxCharacterLimitCity];
const stateValidation = [isValidState];
const zipCodeValidation = [isValidZip];
const zipCodeExtValidation = [isValidZipExt];
const schoolNameValidation = [isValidSchoolName];
const studentIdValidation = [isValidStudentId];

const isRequiredField = (arr) => [isFieldRequired].concat(arr);

export const addSchoolValidationFields = {
  addressOne: isRequiredField(addressOneValidation),
  addressTwo: addressTwoValidation,
  city: isRequiredField(cityValidation),
  state: isRequiredField(stateValidation),
  zipCode: isRequiredField(zipCodeValidation),
  zipCodeExt: zipCodeExtValidation,
  schoolName: isRequiredField(schoolNameValidation),
  studentId: isRequiredField(studentIdValidation),
};
